import { render, staticRenderFns } from "./AssignSinglePositionID.vue?vue&type=template&id=5e4e02b2&"
import script from "./AssignSinglePositionID.vue?vue&type=script&lang=js&"
export * from "./AssignSinglePositionID.vue?vue&type=script&lang=js&"
import style0 from "./AssignSinglePositionID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports